import Flexer from 'js/components/Flexer/Flexer'

import AddToCalendar from './components/AddToCalendar'
import ViewQrCode from './components/ViewQrCode'
import ViewTicketLink from './components/ViewTicketLink'
import styles from './EventActions.module.css'

const EventActions = ({ site, entity }) => {
    const { ticketLink, qrAccess, isAttending } = entity

    return (
        <Flexer
            className={styles.wrapper}
            gutter={false}
            divider
            dividerOffset="lg"
        >
            {ticketLink && <ViewTicketLink entity={entity} />}
            {qrAccess && isAttending === 'accept' && (
                <ViewQrCode entity={entity} />
            )}
            <AddToCalendar site={site} entity={entity} />
        </Flexer>
    )
}

export default EventActions
